import React, { useState, useEffect } from 'react'
import {
  OverlayTrigger,
  Tooltip,
  Tab,
  Tabs,
  Table,
  Row,
  Col,
  Form,
  Button,
  Nav,
} from 'react-bootstrap'

import { v4 as uuidv4 } from 'uuid'
import { auto } from '@popperjs/core'
// import { useMediaQuery } from 'react-responsive'
import * as dayjs from 'dayjs'
import axios from 'axios'
import { useAPI } from '../../hooks/useAPI'

const GroupComprehensive = ({
  title,
  incLastData,
  setIncLastData,
  currentUser,
  setCsvDate,
  setCsvData,
  setIsLoading,
}) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      彙整您旗下所有子品牌/企業的社群經營的成效，提供指標群與排名。整體表現是依據其他五項指標的分數排名加權後由高至低排序。
    </Tooltip>
  )
  const BaseUrl = 'https://kolstarapi.dsigroup.com.tw/'
  const getIncLast = 'powerAnalysis/v1/GetIncLast'
  useEffect(() => {}, [])
  const today = dayjs().format('YYYY-MM-DD')
  const oneWeekBefore = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
  // TODO: 改回來
  const [startDate, setStartDate] = useState(oneWeekBefore)
  const [endDate, setEndDate] = useState(today)
  // const [date, setDate] = useState('')

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value)
  }
  const handleEndDateChange = (event) => {
    setEndDate(event.target.value)
    setCsvDate(event.target.value)
  }
  // 若只要一個日期
  // const handleDateChange = (event) => {
  //   setDate(event.target.value)
  // }
  const allCompanyRequestBody = { date: endDate }

  const searchDate = () => {
    setIsLoading(true)
    // console.log(startDate, endDate)
    axios
      .post(BaseUrl + getIncLast, allCompanyRequestBody, {
        headers: {
          'Content-Type': 'text/plain; charset=UTF-8',
          Accept: '*/*',
          tk: currentUser.tk,
        },
      })
      .then((res) => {
        // console.log('power getIncLast data', res.data.data)
        setIsLoading(false)
        setIncLastData(res.data.data)
      })
      .catch((e) => {
        setIsLoading(false)
        console.log(e)
      })
    if (startDate === '' || endDate === '') {
      setIsLoading(false)
      alert('日期格式錯誤')
    }
    //  else if (startDate && endDate && startDate > endDate) {
    //   alert('結束日期不得小於開始日期')
    // }
  }
  const [sortedTotallyPerformance, setSortedTotallyPerformance] = useState([])
  const [sortedSumfocVal, setSortedSumfocVal] = useState([])
  const [sortedAvefocVal, setSortedAvefocVal] = useState([])
  const [sortedEmofocVal, setSortedEmofocVal] = useState([])
  const [sortedNewattVal, setSortedNewattVal] = useState([])
  const [sortedFanresVal, setSortedFanresVal] = useState([])
  useEffect(() => {
    setSortedTotallyPerformance(
      [...incLastData].sort(function (a, b) {
        return b.totally_performance - a.totally_performance
      })
    )
    setSortedSumfocVal(
      [...incLastData].sort(function (a, b) {
        return b.sumfoc_val - a.sumfoc_val
      })
    )
    setSortedAvefocVal(
      [...incLastData].sort(function (a, b) {
        return b.avefoc_val - a.avefoc_val
      })
    )
    setSortedEmofocVal(
      [...incLastData].sort(function (a, b) {
        return b.emofoc_val - a.emofoc_val
      })
    )
    setSortedNewattVal(
      [...incLastData].sort(function (a, b) {
        return b.newatt_val - a.newatt_val
      })
    )
    setSortedFanresVal(
      [...incLastData].sort(function (a, b) {
        return b.fanres_val - a.fanres_val
      })
    )
  }, [incLastData])

  useEffect(() => {
    setCsvData({
      totallyPerformance: sortedTotallyPerformance,
      sumfocVal: sortedSumfocVal,
      avefocVal: sortedAvefocVal,
      emofocVal: sortedEmofocVal,
      newattVal: sortedNewattVal,
      fanresVal: sortedFanresVal,
    })
  }, [sortedTotallyPerformance])

  // const isMobile = useMediaQuery({ query: '(max-width: 576px)' })
  // const isPad = useMediaQuery({ query: '(max-width: 992px)' })

  return (
    <>
      <Row className="d-flex flex-column flex-lg-row justify-content-between ">
        <div className="mt-2">
          <h4 className="fw-bolder px-3 p-lg-3 mt-3">
            {title}
            <OverlayTrigger
              placement="right"
              delay={{ show: 50, hide: 400 }}
              overlay={renderTooltip}
            >
              <div className="fas fa-question-circle p-1 text-decoration-none"></div>
            </OverlayTrigger>
          </h4>
        </div>

        <Col className="my-2 flex-grow-1">
          <Form className="d-flex flex-row flex-sm-row px-3 p-lg-3 align-items-center">
            <Col className="d-md-flex align-items-center justify-content-between">
              {/* <Col className="d-flex align-items-center">
                <Form.Label className="m-2">開始日期</Form.Label>
                <Col className="my-2">
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={handleStartDateChange}
                  />
                </Col>
              </Col> */}
              <Col className="d-flex align-items-center mx-md-2">
                <Form.Label className="m-2">日期</Form.Label>
                <Col className="my-2">
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={handleEndDateChange}
                  />
                </Col>
              </Col>

              <Col md={auto} className="my-3 mx-auto d-grid d-md-flex">
                <Button
                  className=""
                  variant="secondary"
                  type="button"
                  onClick={searchDate}
                >
                  <i className="fa-solid fa-search "></i>
                  <span> 查詢</span>
                </Button>
              </Col>
            </Col>
          </Form>
        </Col>
      </Row>

      <div className="d-none d-md-block ">
        <Tabs
          defaultActiveKey="totallyPerformance"
          id="justify-tab-example"
          className="mb-3 flex-column flex-sm-row"
          justify
          //   variant="pills"
        >
          <Tab eventKey="totallyPerformance" title="整體表現">
            <Table responsive striped hover>
              <thead>
                <tr>
                  <th>排名</th>
                  <th>品牌</th>
                  <th>數值(分)</th>
                </tr>
              </thead>
              <tbody>
                {sortedTotallyPerformance.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td>{i + 1}</td>
                      <td>{v.kol_name}</td>
                      <td>{v.totally_performance}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="sumfocVal" title="影響擴散力">
            <Table striped hover>
              <thead>
                <tr>
                  <th>排名</th>
                  <th>品牌</th>
                  <th>數值(分)</th>
                </tr>
              </thead>
              <tbody>
                {sortedSumfocVal.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td>{i + 1}</td>
                      <td>{v.kol_name}</td>
                      <td>{v.sumfoc_val}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="avefocVal" title="話題創造力">
            <Table striped hover>
              <thead>
                <tr>
                  <th>排名</th>
                  <th>品牌</th>
                  <th>數值(分)</th>
                </tr>
              </thead>
              <tbody>
                {sortedAvefocVal.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td>{i + 1}</td>
                      <td>{v.kol_name}</td>
                      <td>{v.avefoc_val}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="emofocVal" title="好感渲染力">
            <Table striped hover>
              <thead>
                <tr>
                  <th>排名</th>
                  <th>品牌</th>
                  <th>數值(分)</th>
                </tr>
              </thead>
              <tbody>
                {sortedEmofocVal.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td>{i + 1}</td>
                      <td>{v.kol_name}</td>
                      <td>{v.emofoc_val}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="newattVal" title="新粉吸引力">
            <Table striped hover>
              <thead>
                <tr>
                  <th>排名</th>
                  <th>品牌</th>
                  <th>數值(%)</th>
                </tr>
              </thead>
              <tbody>
                {sortedNewattVal.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td>{i + 1}</td>
                      <td>{v.kol_name}</td>
                      <td>{v.newatt_val}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="fanresVal" title="社群觸及力">
            <Table striped hover>
              <thead>
                <tr>
                  <th>排名</th>
                  <th>品牌</th>
                  <th>數值(人)</th>
                </tr>
              </thead>
              <tbody>
                {sortedFanresVal.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td>{i + 1}</td>
                      <td>{v.kol_name}</td>
                      <td>{v.fanres_val}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Tab>
        </Tabs>
      </div>

      <Tab.Container
        id="left-tabs-example"
        defaultActiveKey="totallyPerformance"
      >
        <Row className="d-md-none ">
          <Col>
            <Nav
              variant="pills"
              className="flex-column comprehensiveAnalysis sticky-top my-2"
            >
              <Nav.Item>
                <Nav.Link eventKey="totallyPerformance">整體表現</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="sumfocVal">影響擴散力</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="avefocVal">話題創造力</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="emofocVal">好感渲染力</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="newattVal">新粉吸引力</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="fanresVal">社群觸及力</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col xs={9} className="tab-pane-mobile">
            <Tab.Content>
              <Tab.Pane eventKey="totallyPerformance">
                <Table responsive striped hover className="my-2">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>品牌</th>
                      <th>分</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedTotallyPerformance.map((v, i) => {
                      return (
                        <tr key={uuidv4()}>
                          <td>{i + 1}</td>
                          <td>{v.kol_name}</td>
                          <td>{v.totally_performance}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Tab.Pane>
              <Tab.Pane eventKey="sumfocVal">
                <Table responsive striped hover className="my-2">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>品牌</th>
                      <th>分</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedSumfocVal.map((v, i) => {
                      return (
                        <tr key={uuidv4()}>
                          <td>{i + 1}</td>
                          <td>{v.kol_name}</td>
                          <td>{v.sumfoc_val}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Tab.Pane>
              <Tab.Pane eventKey="avefocVal">
                <Table responsive striped hover className="my-2">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>品牌</th>
                      <th>分</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedAvefocVal.map((v, i) => {
                      return (
                        <tr key={uuidv4()}>
                          <td>{i + 1}</td>
                          <td>{v.kol_name}</td>
                          <td>{v.avefoc_val}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Tab.Pane>
              <Tab.Pane eventKey="emofocVal">
                <Table responsive striped hover className="my-2">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>品牌</th>
                      <th>分</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedEmofocVal.map((v, i) => {
                      return (
                        <tr key={uuidv4()}>
                          <td>{i + 1}</td>
                          <td>{v.kol_name}</td>
                          <td>{v.emofoc_val}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Tab.Pane>
              <Tab.Pane eventKey="newattVal">
                <Table responsive striped hover className="my-2">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>品牌</th>
                      <th>%</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedNewattVal.map((v, i) => {
                      return (
                        <tr key={uuidv4()}>
                          <td>{i + 1}</td>
                          <td>{v.kol_name}</td>
                          <td>{v.newatt_val}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Tab.Pane>
              <Tab.Pane eventKey="fanresVal">
                <Table responsive striped hover className="my-2">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>品牌</th>
                      <th>人</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedFanresVal.map((v, i) => {
                      return (
                        <tr key={uuidv4()}>
                          <td>{i + 1}</td>
                          <td>{v.kol_name}</td>
                          <td>{v.fanres_val}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </>
  )
}

export default GroupComprehensive
